export default {
  namespaced: true,
  state() {
    return {
      step: 1,
    }
  },
  mutations: {
    SET_STEP( state, payload ) {
      state.step = payload
    },
  }
}